// File: typescript/apps/front-end/src/main/react/Dialog/ReportUserDialogLazy.ts
//
// Lazy delegate for the imperative report-user dialog opener. ReportUserDialog is zod-backed
// (validation/moderation) and is statically reachable from the eager UserButtons chrome, which kept
// `zod` in main_bundle.js on every page. Routing the opener through this thin module loads the heavy
// dialog (and zod) on demand the first time a visitor reports a user. Drop-in replacement for
// `import { showReportUserDialog } from ".../ReportUserDialog"`.
// See designs/01-now/2026-06-29-mobile-cwv-field-regression-...-design.md (N1).

import type {Localizer} from "@/main/react/Types";
import {importChunkWithRetryAndReload} from "@/lib/lazyWithRetry";

export function showReportUserDialog(localizer: Localizer, username?: string, onSuccess?: () => void) {
    void importChunkWithRetryAndReload(
        () => import("@/main/react/Dialog/ReportUserDialog").then((m) => ({default: m.showReportUserDialog})),
        "report-user-dialog",
    ).then((m) => m.default(localizer, username, onSuccess));
}
